import { config } from '~app/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { useQuery } from '@tanstack/react-query';

import { personKeys } from './person-keys';

import type { PersonDataResponse } from '../model';

export const usePersonData = () => {
  return useQuery({
    queryKey: personKeys.get(),
    queryFn: () => {
      return makeRequest<ResponseSuccess<PersonDataResponse>>({
        url: `${config.apiHost}/merchant-origination/api/v1/person/get`,
        httpMethod: 'POST',
        credentials: 'include',
      }).then((response) => response.payload);
    },
  });
};
